var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unit-vimeo-video-player",style:(_vm.wrapperStyles)},[_c('iframe',{staticClass:"unit-vimeo-video-player__iframe",attrs:{"src":_vm.vimeoVideoUrl,"frameborder":"0","allow":"fullscreen; picture-in-picture","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }